import { jsx as o } from "react/jsx-runtime";
const e = (r) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...r,
    children: /* @__PURE__ */ o(
      "path",
      {
        stroke: "currentcolor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m13.655 3.39-3.7 4.858c-.331.324-.519.772-.519 1.237v8.761c0 .965.805 1.754 1.788 1.754h5.006a1.78 1.78 0 0 0 1.635-1.061l2.914-6.674c.76-1.737-.536-3.666-2.458-3.666h-3.263l.85-4.017a1.3 1.3 0 0 0-.367-1.202 1.35 1.35 0 0 0-1.886.01M4.788 20c.983 0 1.788-.79 1.788-1.754V11.23c0-.965-.805-1.754-1.788-1.754-.984 0-1.788.789-1.788 1.754v7.016C3 19.211 3.804 20 4.788 20"
      }
    )
  }
);
export {
  e as default
};
